import type { RideAudioSettings, RideAudioSettingsPatch } from './types.ts';

export const RIDE_SETTINGS_VERSION = 2;

export interface StoredRideSettingsV2 extends RideAudioSettings {
  readonly version: typeof RIDE_SETTINGS_VERSION;
  readonly cameraFov: number;
  readonly cameraShake: number;
  readonly reducedMotion: boolean;
  readonly testSpeed?: 0.5 | 1 | 2 | 4;
}

export const DEFAULT_RIDE_AUDIO_SETTINGS: RideAudioSettings = Object.freeze({
  masterVolume: 0.8,
  musicVolume: 0.62,
  rideVolume: 0.85,
  windVolume: 0.7,
  environmentVolume: 0.58,
  uiVolume: 0.7,
  reactionVolume: 0.9,
  muted: false,
});

function normalizeVolume(value: unknown, fallback: number): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) return fallback;
  return Math.min(1, Math.max(0, value));
}

export function migrateStoredRideAudioSettings(candidate: unknown): RideAudioSettings {
  if (!candidate || typeof candidate !== 'object') return DEFAULT_RIDE_AUDIO_SETTINGS;
  return normalizeRideAudioSettings(candidate as RideAudioSettingsPatch);
}

export function normalizeRideAudioSettings(
  candidate: RideAudioSettingsPatch | undefined,
  fallback: RideAudioSettings = DEFAULT_RIDE_AUDIO_SETTINGS,
): RideAudioSettings {
  return {
    masterVolume: normalizeVolume(candidate?.masterVolume, fallback.masterVolume),
    musicVolume: normalizeVolume(candidate?.musicVolume, fallback.musicVolume),
    rideVolume: normalizeVolume(candidate?.rideVolume, fallback.rideVolume),
    windVolume: normalizeVolume(candidate?.windVolume, fallback.windVolume),
    environmentVolume: normalizeVolume(candidate?.environmentVolume, fallback.environmentVolume),
    uiVolume: normalizeVolume(candidate?.uiVolume, fallback.uiVolume),
    reactionVolume: normalizeVolume(candidate?.reactionVolume, fallback.reactionVolume),
    muted: typeof candidate?.muted === 'boolean' ? candidate.muted : fallback.muted,
  };
}
